import React, { useContext } from 'react';
import { Col, Row } from 'reactstrap';
import { PropTypes } from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import isEmpty from 'lodash.isempty';
import GoBackButton from '../shared/GoBackButton';
import CardTemplate from '../shared/CardTemplate';
import { paths, terminusCardId, KIOSK_MODE } from '../../constants';
import { PortalContainer, CardHeader, StyledAlert } from '../../styles/common';
import { AppStateContext } from '../../context/AppContext';
import { BrandingStateContext } from '../../context/BrandingContext';

const Status = ({ title, state, path }) => {
    const { t } = useTranslation();
    const { viewMode } = useContext(AppStateContext);
    const { kiosk } = useContext(BrandingStateContext);
    const { statusMessage, errorMessage } = state || {};
    const isKiosk = viewMode === KIOSK_MODE;
    const msg =
        t(`${statusMessage}${isKiosk && !errorMessage ? '$kiosk' : ''}`) ||
        statusMessage ||
        t('terminusDefault');
    const hideBackBtn =
        isKiosk && !isEmpty(kiosk) && kiosk.terminusSuccessButton === 'false';
    console.debug(`Walkway Status ${title}: `, state);
    return (
        <CardTemplate title={title} testId={terminusCardId}>
            <PortalContainer>
                <Row>
                    <Col sm="12">
                        <CardHeader>
                            {t('terminusCardLabels$stateless$h6')}
                        </CardHeader>
                    </Col>
                    <Col sm="12">
                        <StyledAlert color={errorMessage ? 'danger' : 'success'}>
                            <Trans
                                components={{
                                    a: <a /> // a link may be provided by the message
                                }}
                            >
                                {msg}
                            </Trans>
                        </StyledAlert>
                    </Col>
                    <Col sm="12">
                        {!hideBackBtn && <GoBackButton path={path} />}
                    </Col>
                </Row>
            </PortalContainer>
        </CardTemplate>
    );
};

Status.propTypes = {
    title: PropTypes.string,
    state: PropTypes.object,
    path: PropTypes.string,
};

Status.defaultProps = {
    path: paths.identities,
};

export default Status;
